import { Component } from '@angular/core';
import { GetAllStatusesData } from '@dataconnect/account'
import { Store } from '@ngrx/store';
import { QueryResult } from 'firebase/data-connect';
import { combineLatest, debounceTime, filter, lastValueFrom, take, takeUntil, tap } from 'rxjs';
import { authUserFeature } from '../../store/authUser.store';
import { Logger } from '../../helper/logger';
import { accountFeature } from '../../store/account.store';
import { listingsFeature, ListingsPageActions } from '../../store/listings.store';
import { ListingPublic } from '../../../../globalTypes/listings.types';
import { ListingService } from '../../services/listing.service';
import { Base } from '../../component/wrapper/base-wrapper.component';
import { ListingsCardComponent } from '../../component/layout/element/listing-card.component';
import { WrapperPageComponent } from "../../component/wrapper/page-wrapper.component";
import { SearchSideBarComponent } from "./search-side-bar.component";
import { LocationPublic } from '../../../../globalTypes/account.types';
import { FormsModule } from '@angular/forms';
import { SideDrawerComponent } from "../../component/layout/element/side-drawer.component";
import { CartComponent } from "../order/cart.component";
import { AuthUser } from '../../../../globalTypes/auth.types';
import { searchActions, searchFeature } from '../../store/search.store';
import { ButtonComponent } from "../../component/layout/element/button.component";
const log = new Logger('SearchComponent');

@Component({
  selector: 'msh-search',
  imports: [ListingsCardComponent, WrapperPageComponent, FormsModule, SearchSideBarComponent, SideDrawerComponent, CartComponent, ButtonComponent],
  template: `

  <msh-page-wrapper>
    @if(location){
      <msh-side-drawer [isHidden]="false">
        <div class="m-8">
          <msh-cart [standAlone]="true"></msh-cart>
        </div>
      </msh-side-drawer >
    }
    <div left-side-bar class=" fixed md:relative border-b md:border-none md:mt-4 w-full z-10 max-h-[90vh] ">
      <msh-search-side-bar></msh-search-side-bar>
    </div>
      @if(listings.length){
        <span class="hidden" >DOM needs {{location.id}} to help sync with listing cards</span>
        <div [class]="(listingsLoading ? ' animate-custom-pulse-opacity ' : '')+' grid mt-16 md:mt-4 gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'">
            @for(listing of listings; track listing.id){
              <msh-listings-card
                [userId]="authUser && authUser.id ? authUser.id : undefined"
                [listing]="listing"
                [locationId]="location?.id"
                [locations]="locations"
                [verifiedLocationNoun]="verifiedLocationNoun"
                class="flex justify-center"
              ></msh-listings-card>
            }
        </div>
      } @else if(isLoading){
        <div class="null mt-16 text-center">Loading results<span class=" animate-bounce">.</span></div>
      } @else {
        <div class="null mt-16 text-center">No results</div>
      }
    <div class=" flex justify-center my-8" >
      @if(couldBeMore){
        <msh-button [stealthMode]="true" cta="load more" (onClick)="loadMore()" > </msh-button>
      }
    </div>
  </msh-page-wrapper>

  `,
  styles: ``
})
export class SearchComponent extends Base<SearchComponent> {
  authUser!: AuthUser;
  statuses!: QueryResult<GetAllStatusesData, undefined>; // = getAllStatuses();
  listings: ListingPublic[] = [];
  location: any
  locations: {[locationId: string]: LocationPublic} = {};
  verifiedLocationNoun?: string
  useParamsString = '';  
  couldBeMore = false;
  listingsLoading = false;
  isLoading = true;

constructor(
  private store: Store,
  private listingsService: ListingService,
  ) {
    super();
    this.store.select(accountFeature.selectLocation).pipe(takeUntil(this.$destroy)).subscribe(loc=>{
      this.location = loc; // JSON.parse(JSON.stringify(loc));
    });
    this.store.select(accountFeature.selectLocations).pipe(takeUntil(this.$destroy)).subscribe(locations=>{
      this.locations = locations
    });

    this.store.select(accountFeature.selectSegment).pipe(takeUntil(this.$destroy)).subscribe(segment=>{
      const noun = segment?.verifiedLocationNoun + '';
      const capitalizedNoun = noun?.charAt(0).toUpperCase() + noun?.slice(1);
      this.verifiedLocationNoun = capitalizedNoun;
    });
    this.store.dispatch(searchActions.clearSearch());
    this.store.dispatch(ListingsPageActions.clearListing())
  }
  async ngOnInit() {
    combineLatest([
      this.store.select(searchFeature.selectParams),
      this.store.select(accountFeature.selectLocation)
    ]).pipe(
      filter(([params, location])=>!!params && Object.values(params).sort((a,b)=>a<b?1:-1).join(",") !== this.useParamsString),
      tap(([params, location])=>{this.useParamsString = Object.values(params).sort((a,b)=>a<b?1:-1).join(",")}),
      takeUntil(this.$destroy),
      debounceTime(500),
    ).subscribe(async ([params, location])=>{
      log.log({onSelectParamsChange: this.useParamsString, params, location})
      this.couldBeMore = await this.listingsService.loadFilteredListings()
    })
    this.store.select(listingsFeature.selectListingsState).pipe(takeUntil(this.$destroy)).subscribe(state => {
      log.log({onListingStateChange: state})
      this.isLoading = state.isLoading;
      const listings = state.ids.filter(id=>!!state.entities[id]).map(id => state.entities[id]);
      this.listings = listings as ListingPublic[];
      log.log({listings})
      this.listingsLoading = state.isLoading;
    })
    this.authUser = await lastValueFrom(this.store.select(authUserFeature.selectUser).pipe(filter(u=>!!u), take(1)))
    // // TODO: add user preferences to load the right results
   
  }

  async loadMore(){
    // add page
    this.store.dispatch(searchActions.increaseLoadAmount());
    this.couldBeMore = await this.listingsService.loadFilteredListings(true);
  }

}
